import styled from 'styled-components'
import { grayText, white, black, purple, purpleSec } from 'theme/colors'

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  width: 450px;
  min-width: 450px;
  min-height: 240px;
  background: ${white};
  border-radius: 6px;
  margin-bottom: 0px;
  flex-shrink: 0;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 402px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 402px;
  height: 52px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`

export const Title = styled.h3`
  width: 402px;
  height: 24px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: ${black};
  margin: 0;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`

export const Subtitle = styled.h4`
  width: 402px;
  height: 24px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: ${black};
  margin: 0;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 402px;
  height: auto;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`

export const InfoText = styled.p`
  width: 402px;
  height: auto;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 154.7%;
  text-align: center;
  color: ${grayText};
  margin: 0;
  white-space: pre-line;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 0px;
  gap: 16px;
  width: 402px;
  height: 42px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`

export const SecondaryButton = styled.button`
  width: 193px;
  height: 42px;
  background: ${purpleSec};
  border-radius: 6px;
  border: none;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 154.7%;
  text-align: center;
  color: ${purple};
  cursor: pointer;
  flex: none;
  order: 0;
  flex-grow: 1;

  &:hover {
    opacity: 0.9;
  }
`

export const PrimaryButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 193px;
  height: 42px;
  background: ${purple};
  border-radius: 4px;
  border: none;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 154.7%;
  text-align: center;
  color: ${white};
  cursor: pointer;
  flex: none;
  order: 1;
  flex-grow: 1;

  &:hover {
    opacity: 0.9;
  }
`

export const SingleButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 50%;
  height: 42px;
  background: ${purple};
  border-radius: 4px;
  border: none;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 154.7%;
  text-align: center;
  color: ${white};
  cursor: pointer;
  flex: none;
  order: 0;
  align-self: stretch;

  &:hover {
    opacity: 0.9;
  }
`
